import { FormControl, InputLabel } from "@mui/material";
import InputMask from "react-input-mask";
import { Controller, useFormContext } from "react-hook-form";
import styles from "../Cadastro.module.css";
import { useEffect, useState } from "react";
import { OcupantesSearchField } from "../../../../components/Searchfields/Ocupantes";
import servOcupante from "../../../../services/login/servOcupante";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { CidadesSearchField } from "../../../../components/Searchfields/Cidades";
import { HelperText } from "../../../../components/Errors/HelperText";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import Select from "react-select";
import { useSelector } from "react-redux";
import { validarCpf } from '../../../../infra/utils/ValidacaoCpf';
import servSolicitacaoCompartilhamento from "../../../../services/login/servSolicitacaoCompartilhamento";
import { BairrosSearchField } from "../../../../components/Searchfields/Bairros";

const optionsTipoCabo = [
  { value: 1, label: "Metálico" },
  { value: 2, label: "Óptico" },
];

const selectStyles = {
  control: (styles) => ({
    ...styles,
    marginTop: "15px",
    color: "#707070",
    backgroundColor: "#343434",
    borderRadius: "10px",
    padding: "3px",
  }),
  option: (styles, { isDisabled }) => {
    return {
      ...styles,
      backgroundColor: "#343434",
      color: "#707070",
      border: "none",
    };
  },
  input: (styles) => ({ ...styles, color: "#707070" }),
  singleValue: (styles) => ({ ...styles, color: "#707070" }),
  menuList: (styles) => ({ ...styles, backgroundColor: "#343434" }),
};

const Geral = ({
  disableCampos,
  setOpen,
  setDisableAba,
  setErrorMessage,
  setOpenError,
  setPodeSalvar,
  recordForEdit,
  methods,
  onKeyDown,
  situacao,
  fazFiscalizacao,
  exibirAbaPontos,
  cpfInvalido,
  setCpfInvalido,
  campoQtdeObrig,
  setCampoQtdeObrig
}) => {
  const {
    control,
    register,
    setValue,
    watch,
    setError,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const [editavel, setEditavel] = useState(false);
  const [situacaoRevisao, setSituacaoRevisao] = useState(false);
  const user = useSelector((state) => state.user);

  useEffect(() => {
    const situacaoEditaveisDigitacao = [0];
    const situacaoEditaveisRevisao = [0, 2];

    setEditavel(!situacaoEditaveisDigitacao.includes(situacao));
    setSituacaoRevisao(!situacaoEditaveisRevisao.includes(situacao));
  }, [situacao]);

  useEffect(() => {
    if (recordForEdit && recordForEdit.codigoOcupante) {
      setValue("codigoOcupante", recordForEdit.codigoOcupante);
    }
  }, [recordForEdit, setValue]);

  const watchCodigoOcupante = watch("codigoOcupante");
  const watchCodigoCidade = watch("codigoCidade");
  const watchCodigoBairro = watch("codigoBairro");

  useEffect(() => {
    const fetchCidadeOcupante = async () => {
      if (watchCodigoOcupante?.codigo) {
        try {
          const response = await servOcupante.listarCFiltroCode(
            user.codigoUsuario,
            watchCodigoOcupante.codigo
          );
          const responseRepresentante =
            await servSolicitacaoCompartilhamento.SugerirRepresentante({
              CodigoResponsavelTecnico: user.codigoUsuario,
              CodigoOcupante: watchCodigoOcupante.value,
            });
          if (response?.Content[0].Cidades) {
            setValue("codigoCidade", {
              value: response.Content[0].Cidades.Id,
              label: response.Content[0].Cidades.Nome,
              rawData: response.Content[0].Cidades,
            });
          }

          if (responseRepresentante?.Content?.Content) {
            setValue(
              "nomeRepresentante",
              responseRepresentante?.Content?.Content.Nome
            );
            setValue(
              "cpfRepresentante",
              responseRepresentante?.Content?.Content.Inscricao
            );
          }
        } catch (err) {
          setOpenError(true);
          setErrorMessage(
            err?.response?.data?.Message || "Erro ao buscar ocupante"
          );
        }
      }
    };

    fetchCidadeOcupante();
  }, [
    watchCodigoOcupante,
    setValue,
    user.codigoUsuario,
    setOpenError,
    setErrorMessage,
  ]);

  useEffect(() => {
    if (watchCodigoCidade) {
      setValue("Cidades", { value: watchCodigoCidade.value, label: watchCodigoCidade.label });
      clearErrors('Cidades');
    }
  }, [watchCodigoCidade]);

  useEffect(() => {
    if (watchCodigoBairro) {
      setValue("Bairros", { value: watchCodigoBairro.value, label: watchCodigoBairro.label });
      setValue("codigoRegiao", watchCodigoBairro.codigoRegiao);
      clearErrors('Bairros');
    }
  }, [watchCodigoBairro]);

  return (
    <div style={{ width: "100%" }}>
      <div className={styles["input-container"]}>
        <Controller
          name="codigoOcupante"
          control={control}
          render={({ field }) => (
            <FormControl
              variant="outlined"

              className={
                exibirAbaPontos ? styles["campos-g"] : styles["campos-e"]
              }
              style={{ zIndex: 2 }}
            >
              <InputLabel
                shrink
                htmlFor="codigo-ocupante"
                sx={{ color: "#b8b8b8" }}
              >
                Ocupante
              </InputLabel>
              <OcupantesSearchField
                field={field}
                id="codigo-ocupante"
                setOpenError={setOpenError}
                setErrorMessage={setErrorMessage}
                onKeyDown={onKeyDown}
                disabled={editavel}
                className={`${errors?.codigoOcupante ? styles.campoComValorErrado : ""
                  }`}
              />
              {errors?.codigoOcupante ? (
                <HelperText text={errors?.codigoOcupante.value?.message} />
              ) : (
                ""
              )}
            </FormControl>
          )}
        />
        {!exibirAbaPontos && (
          <div>
            <Controller
              name="qtdePontos"
              control={control}
              render={({ field }) => (
                <FormControl
                  variant="outlined"
                  style={{ paddingRight: "66px" }}
                >
                  <InputLabel
                    htmlFor="ocupante-qtde-pontos"
                    shrink
                    sx={{ color: "#b8b8b8" }}
                  >
                    Quantidade de pontos
                  </InputLabel>
                  <WhiteInput
                    fullWidth
                    placeholder="Quantidade de pontos"
                    type="number"
                    id="ocupante-qtde-pontos"
                    error={!!errors.qtdePontos}
                    {...field}
                    onChange={(e) => {
                      field.onChange(e);
                      if (e.target.value === "" || e.target.value <= 0) {
                        setCampoQtdeObrig(true);
                      } else {
                        setCampoQtdeObrig(false);
                      }
                    }}
                    readOnly={disableCampos || situacaoRevisao}
                    className={`${errors?.qtdePontos || campoQtdeObrig ? styles.campoComValorErrado : ""
                      }`}
                  />
                  {errors?.qtdePontos || campoQtdeObrig ? (
                    <HelperText text={errors?.qtdePontos?.message || "Campo obrigatório"} />
                  ) : (
                    ""
                  )}
                </FormControl>
              )}
            />
          </div>
        )}
      </div>
      <div className={styles["input-container"]}>
        <Controller
          name="nomeRepresentante"
          control={control}
          render={({ field }) => (
            <FormControl variant="outlined" className={styles["campos-m"]}>
              <InputLabel
                htmlFor="ocupante-nomeRepresentante"
                shrink
                sx={{ color: "#b8b8b8" }}
              >
                Nome do representante
              </InputLabel>
              <WhiteInput
                fullWidth
                placeholder="Nome do representante"
                type="text"
                id="ocupante-nomeRepresentante"
                error={!!errors.nomeRepresentante}
                autoComplete="off"
                {...field}
                readOnly={disableCampos || situacaoRevisao}
                className={`${errors?.nomeRepresentante ? styles.campoComValorErrado : ""
                  }`}
              />
              {errors?.nomeRepresentante ? (
                <HelperText text={errors?.nomeRepresentante?.message} />
              ) : (
                ""
              )}
            </FormControl>
          )}
        />
        <Controller
          name="cpfRepresentante"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <FormControl variant="outlined" className={styles["campos-m"]}>
              <InputLabel
                htmlFor="consulta-cpfRepresentante"
                shrink
                sx={{ color: "#b8b8b8" }}
              >
                CPF representante
              </InputLabel>
              <InputMask
                mask={"999.999.999-99"}
                onChange={(e) => {
                  if (disableCampos || situacaoRevisao) return;
                  onChange(e);
                  const cpf = e.target.value;
                  if (cpf && !validarCpf(cpf)) {
                    setError("cpfRepresentante", {
                      type: "manual",
                      message: "CPF inválido",
                    });
                  } else {
                    setCpfInvalido(false);
                    clearErrors("cpfRepresentante");
                  }
                }}
                value={value}
                readOnly={disableCampos}
                id="consulta-cpfRepresentante"
              >
                {(inputProps) => (
                  <WhiteInput
                    fullWidth
                    placeholder="CPF"
                    name="cpfRepresentante"
                    {...inputProps}
                    readOnly={disableCampos || situacaoRevisao}
                    autoComplete="off"
                    className={`${cpfInvalido ? styles.campoComValorErrado : ""
                      }`}
                  />
                )}
              </InputMask>
              {cpfInvalido ? (
                <HelperText text={"CPF inválido"} />
              ) : (
                ""
              )}
            </FormControl>
          )}
        />
      </div>
      <div className={styles["input-container"]}>
        <Controller
          name="emailRepresentante"
          control={control}
          render={({ field }) => (
            <FormControl variant="outlined" className={styles["campos-m"]}>
              <InputLabel
                htmlFor="cadastro-email"
                shrink
                style={{ color: "#B8B8B8" }}
              >
                E-mail representante
              </InputLabel>
              <WhiteInput
                fullWidth
                type="email"
                placeholder="E-mail"
                id="cadastro-email"
                {...field}
                error={!!errors.EmailRepresentante}
                autoComplete="off"
                readOnly={disableCampos || situacaoRevisao}
                className={`${errors?.EmailRepresentante ? styles.campoComValorErrado : ""
                  }`}
              />
              {errors?.EmailRepresentante ? (
                <HelperText text={errors?.EmailRepresentante?.message} />
              ) : (
                ""
              )}
            </FormControl>
          )}
        />
        <FormControl variant="outlined" className={styles["campos-m"]}>
          <InputLabel
            htmlFor="solcomp-tipocabo"
            shrink
            style={{ color: "#B8B8B8", zIndex: 0 }}
          >
            Tipo de cabos
          </InputLabel>
          <Controller
            name="tipoCabo"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                error={!!errors.tipoCabo}
                options={optionsTipoCabo}
                styles={!editavel ? selectStyles : {
                  control: (styles) => ({
                    ...styles,
                    marginTop: "15px",
                    color: "#B8B8B8",
                    backgroundColor: "#565656",
                    border: "none",
                    borderRadius: "10px",
                    padding: "3px",
                  }),
                  option: (styles, { isDisabled }) => {
                    return {
                      ...styles,
                      backgroundColor: "#343434",
                      color: "#B8B8B8",
                      border: "none",
                    };
                  },
                  input: (styles) => ({ ...styles, color: "#B8B8B8" }),
                  singleValue: (styles) => ({ ...styles, color: "#B8B8B8" }),
                  menuList: (styles) => ({ ...styles, backgroundColor: "#343434" }),
                }}
                placeholder="Selecione o tipo de cabo"
                isDisabled={editavel}
                className={`${errors?.tipoCabo ? styles.campoComValorErrado : ""
                  }`}
              />
            )}
          />
          {errors?.tipoCabo ? (
            <HelperText text={"Este campo é obrigatório"} />
          ) : (
            ""
          )}
        </FormControl>
      </div>
      <div className={styles["input-container"]}>
        <Controller
          name="codigoCidade"
          control={control}
          render={({ field }) => (
            <FormControl variant="outlined" className={styles["campos-m"]}>
              <InputLabel
                htmlFor="consulta-cidade"
                shrink
                sx={{ color: "#b8b8b8" }}
              >
                Cidade{" "}
                <FontAwesomeIcon
                  title="Para facilitar a procura, digite o nome da cidade desejada no campo abaixo."
                  style={{
                    marginLeft: "10px",
                    width: "15px",
                    height: "15px",
                    cursor: "pointer",
                  }}
                  icon={faQuestionCircle}
                />
              </InputLabel>
              <CidadesSearchField
                field={field}
                id="consulta-cidade"
                setOpenError={setOpenError}
                setErrorMessage={setErrorMessage}
                onKeyDown={onKeyDown}
                disabled={editavel}
                className={`${errors?.Cidades ? styles.campoComValorErrado : ""
                  }`}
              />
              {errors?.Cidades ? (
                <HelperText text={errors?.Cidades?.value?.message} />
              ) : (
                ""
              )}
            </FormControl>
          )}
        />

        <Controller
          name="codigoBairro"
          control={control}
          render={({ field }) => (
            <FormControl variant="outlined" className={styles["campos-m"]}>
              <InputLabel
                htmlFor="consulta-bairro"
                shrink
                sx={{ color: "#b8b8b8", zIndex: 0 }}
              >
                Bairro{" "}
                <FontAwesomeIcon
                  title="Para facilitar a procura, digite o nome do bairro desejado no campo abaixo."
                  style={{
                    marginLeft: "10px",
                    width: "15px",
                    height: "15px",
                    cursor: "pointer",
                  }}
                  icon={faQuestionCircle}
                />
              </InputLabel>
              <BairrosSearchField
                field={field}
                id="consulta-bairro"
                setOpenError={setOpenError}
                setErrorMessage={setErrorMessage}
                onKeyDown={onKeyDown}
                disabled={editavel || !watchCodigoCidade}
                className={`${errors?.Bairros ? styles.campoComValorErrado : ""}`}
                watchCodigoCidade={watchCodigoCidade}
                tipoKey={watchCodigoCidade?.value || 'all'}
                setOpen={setOpen}
              />
              {errors?.Bairros ? (
                <HelperText text={errors?.Bairros?.value?.message} />
              ) : (
                ""
              )}
            </FormControl>
          )}
        />
      </div>
    </div>
  );
};

export { Geral };
